import Pagination from 'react-responsive-pagination';

const PaginationComponent = ({ page, total, setPage }: any) => {
    const handleChange = (newPage: number): void => {
        setPage(newPage);
    }

    return (
        <Pagination
            current={page}
            total={total}
            onPageChange={handleChange}
            maxWidth={2}
        />
    );
};

export default PaginationComponent;